module.exports = __webpack_public_path__ + "Roboto-Medium.4d9f3f9e5195e7b074bb.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Medium.eot
// module id = ../../../../../font/roboto/Roboto-Medium.eot
// module chunks = styles